module.exports = __webpack_public_path__ + "static/media/1.2d6530e0.jpg";